import type { ReactNode } from 'react';
import { create } from 'zustand';

export type ConfirmOptions = {
    /** Modal title */
    title: string;
    /** Modal content - can be string or ReactNode */
    content: ReactNode;
    /** OK button text */
    okText?: string;
    /** Cancel button text */
    cancelText?: string;
    /** Use danger styling for OK button */
    okDanger?: boolean;
    /** Handler called when OK is clicked. Can be async. */
    onOk?: () => void | Promise<void>;
    /** Handler called when Cancel is clicked */
    onCancel?: () => void;
    /** Custom icon (defaults to CircleAlert) */
    icon?: ReactNode;
    /** Modal width */
    width?: number;
};

type ConfirmModalState = {
    isOpen: boolean;
    isLoading: boolean;
    options: ConfirmOptions | null;
    show: (options: ConfirmOptions) => void;
    hide: () => void;
    setIsLoading: (isLoading: boolean) => void;
};

export const useConfirmModalStore = create<ConfirmModalState>((set) => ({
    isOpen: false,
    isLoading: false,
    options: null,

    show(options) {
        set({
            isOpen: true,
            isLoading: false,
            options,
        });
    },

    hide() {
        set({
            isOpen: false,
            isLoading: false,
        });
    },

    setIsLoading(isLoading) {
        set({
            isLoading,
        });
    },
}));
